module.exports = __webpack_public_path__ + "static/media/jail.aae9ae9c.jpg";